import { AddJobsRecord, Route, RouteJob, RouteJobDetails, RoutingType } from "./routingApi";

export type RoutingListFilters = {
  searchTerm: string
  active: boolean
  crewMemberIds: string[]
  routeType: RoutingType | null
  sortField?: 'createdAtUtc' | 'crewMemberName'
  sortDirection?: 'asc' | 'desc'
}

export const defaultRoutingListFilters: RoutingListFilters = {
  searchTerm: '',
  active: false,
  crewMemberIds: [],
  routeType: null,
  sortField: 'createdAtUtc',
  sortDirection: 'desc',
}

export type Action =
  | { type: 'ROUTES_LOADED', value: Route[] }
  | { type: 'ROUTES_FILTERED', value: Route[] }

export const reducer = (state: Route[], action: Action): Route[] => {
  switch (action.type) {
    case 'ROUTES_LOADED':
      return [...action.value]
    case 'ROUTES_FILTERED':
      return [...action.value]
    default:
      return state
  }
}

export const getFilteredRoutes = (routes: Route[], filters: RoutingListFilters, crew?: { id: number, name: string }[]): Route[] => {
  let filtered = routes.filter(x =>
    (x.name.toLowerCase().includes(filters.searchTerm.toLowerCase())) &&
    (filters.active ? x.active : true) &&
    (filters.crewMemberIds.length === 0 || 
      (x.crewMemberIds && filters.crewMemberIds.some(id => x.crewMemberIds?.split(',').includes(id)))) &&
    (filters.routeType === null || filters.routeType === undefined || x.routeType === filters.routeType)
  );
  if (filters.sortField === 'crewMemberName') {
    filtered = filtered.sort((a, b) => {
      const aFirstCrewId = a.crewMemberIds?.split(',')[0];
      const bFirstCrewId = b.crewMemberIds?.split(',')[0];
      const aName = aFirstCrewId ? (crew?.find(c => c.id === parseInt(aFirstCrewId))?.name || '') : '';
      const bName = bFirstCrewId ? (crew?.find(c => c.id === parseInt(bFirstCrewId))?.name || '') : '';
      return (aName.localeCompare(bName)) * (filters.sortDirection === 'asc' ? 1 : -1);
    });
  } else {
    filtered = filtered.sort((a, b) => {
      const aVal = a.createdAtUtc;
      const bVal = b.createdAtUtc;
      return (aVal.localeCompare(bVal)) * (filters.sortDirection === 'asc' ? 1 : -1);
    });
  }
  return filtered;
};

export const findRouteJobDetails = (
  routeJob: RouteJob,
  jobsForCreateRoute: AddJobsRecord[] | undefined
): RouteJobDetails | undefined => {
  if (routeJob.jobId === null) {
    return undefined
  }

  if (routeJob.job) {
    return routeJob.job
  }

  return jobsForCreateRoute?.find(j => j.jobId === routeJob.jobId)
}

export const isRouteJobSold = (
  routeJob: RouteJob,
  jobsForCreateRoute: AddJobsRecord[] | undefined
): boolean => {
  if (!jobsForCreateRoute || routeJob.jobId === null) {
    return true
  }

  return jobsForCreateRoute.some(job => job.jobId === routeJob.jobId)
}

export const defaultRouteJob = (): RouteJob => ({
  id: 0,
  routeId: 0,
  jobId: null,
  tenantLocationId: null,
  estimatedDurationInMinutes: 0,
  workAreaIds: '',
  tenantId: 0,
  sortIndex: 0,
  job: null
})
